<template>
  <div>
    <div
      class="slider"
      id="slider"
      ref="slider"
      @click.stop="handelClickSlider"
      @touchmove="controlMove"
      @touchend="controlEnd"
    >
      <div class="process" :style="{ width: per + '%' }"></div>
      <div class="thunk" id="thunk" ref="trunk" :style="{ left: thunkper }">
        <div class="block" ref="dot" @touchstart="sliderStart"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "slider-view",
  //  props: ["min", "max", "value"],
  props: {
    value: {
      type: Number,
      default: 0,
    },
     min: {
      type: Number,
      default: 0,
    },
     max: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      slider: null,
      thunk: null,
      per: this.value,
      thunkper: "20px",
      element: null,
      //滑动到位置的高度
      progressWidth: 0,
      //移动的类型，用来标明是否在拖动进度条
      moveType: 0,
      //拖动开始时点击的位置
      moveOffsetX: 0,
      //拖动开始时进度条的宽度度
      curWidth: 0,
    };
  },
  watch: {
    value(e) {
      let element = document.getElementById("slider");
      if (e > 0) {
        this.thunkper = element.offsetWidth * (e / 100) - 20 + "px";
      } else {
        this.thunkper = "-10px";
      }
      this.per = this.value;
    },
  },
  mounted() {
    const { right } = document.getElementById("slider").getBoundingClientRect();
    this.progressWidth = (right * this.per) / 100;
    this.element = document.getElementById("slider");
    this.thunkper =
      (this.element.offsetWidth ? this.element.offsetWidth : 370) *
        (this.value / 100) -
      20 +
      "px";
    this.slider = this.$refs.slider;
    this.thunk = this.$refs.trunk;
    var _this = this;
    this.thunk.onmousedown = function (e) {
      var width = parseInt(_this.width);
      var disX = e.clientX;
      document.onmousemove = function (e) {
        var newWidth = e.clientX - disX + width;
        var scale = newWidth / _this.slider.offsetWidth;
        _this.per = Math.ceil((_this.max - _this.min) * scale + _this.min);
        _this.per = Math.max(_this.per, _this.min);
        _this.per = Math.min(_this.per, _this.max);
        _this.$emit("move", _this.per);
      };
      document.onmouseup = function () {
      
        _this.controlEnd();
        document.onmousemove = document.onmouseup = null;
        
      };
      return false;
    };
  },
  methods: {
    handelClickSlider(event) {
     
      const dot = this.$refs.dot;
      if (event.target == dot) return;
      event.preventDefault();
      const { left } = document
        .getElementById("slider")
        .getBoundingClientRect();
      this.progressWidth = event.clientX - left;
      //获取元素的宽度l
      let width = this.element.offsetWidth;
      //获取元素的左边距
      let ev = event || window.event;
      //获取当前点击位置的百分比
      let scale = ((ev.offsetX / width) * 100).toFixed(4);
      this.per = scale;
      this.$emit("move", this.per);
      this.controlEnd();
    },
    sliderStart(e) {
      e.preventDefault();
      this.moveOffsetX = e.touches[0].clientX;
      this.moveType = "slider";
      this.curWidth = this.progressWidth;
    },
    controlMove(e) {
      if (this.moveType !== "slider") {
        return false;
      }
      e.preventDefault();
      // 滑动距离可视区域左侧的距离
      const X = e.touches[0].clientX;
      //得到本次拖动已经过的距离
      const cl = X - this.moveOffsetX;
      //容器的宽度
      const { width } = document
        .getElementById("slider")
        .getBoundingClientRect();
      //得到已拖动到宽度
      const ml = this.curWidth + cl;
      let proWidth;
      if (ml <= 0) {
        //进度条长度最小和最大值的界定
        proWidth = 0;
      } else if (ml >= width) {
        proWidth = width;
      } else {
        proWidth = ml;
      }
      this.per = ((proWidth / width) * 100).toFixed(4);
      this.$emit("move", this.per);
      this.progressWidth = proWidth;
      // 更新当前时间
    },
    controlEnd() {
      this.moveType = "";
      this.$emit("moveEnd", this.per);
    },
  },
  computed: {
    scale() {
      return (this.per - this.min) / (this.max - this.min);
    },
    width() {
      if (this.slider) {
        return this.slider.offsetWidth * this.scale + "px";
      } else {
        return 0 + "px";
      }
    },
    left() {
      if (this.slider) {
        return (
          this.slider.offsetWidth * this.scale -
          this.thunk.offsetWidth / 2 +
          "px"
        );
      } else {
        return 0 + "px";
      }
    },
  },
};
</script>
<style scoped>
.slider {
    user-select: none;
    position: relative;
    margin: 0;
    width: 100%;
    height: 12px;
    background: #e4e7ed;
    border-radius: 5px;
    cursor: pointer;
}

.slider .process {
    position: absolute;
    left: 0;
    top: 0;
    height: 12px;
    border-radius: 12px;
 background-color: #F2AC3F;
}

.slider .thunk {
    position: absolute;
    left: 100px;
    top: -14px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
}

.slider .block {
    width: 30px;
    height: 30px;
    background-image: url('@/assets/image9.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition: 0.2s all;
}
</style>